import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
  selector: 'app-login-sso',
  imports: [CommonModule, MatProgressSpinnerModule, MatCardModule],
  templateUrl: './login-sso.component.html',
  styleUrl: './login-sso.component.scss',
})
export class LoginSsoComponent implements OnInit {
  private readonly oidcSecurityService = inject(OidcSecurityService);

  ngOnInit(): void {
    this.oidcSecurityService.authorize();
  }
}
